import React from 'react';
import PropTypes from 'prop-types';

const ConfirmationPopup = ({ onCancel, deleteTaskMail, taskToDeleteId, boardName = "Board", customMessage }) => {
    return (
        <div className="popup">
            <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center z-[8] sm:p-0">
                        <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[395px] ">
                            {customMessage && (
                                <button
                                    type="button"
                                    className="absolute top-2 right-2 p-2 text-gray-400 hover:text-gray-600 focus:outline-none"
                                    onClick={onCancel}
                                    aria-label="Close"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            )}
                            <div className="bg-white px-4  sm:p-6 sm:pb-4">
                                <div className="sm:flex sm:items-start">
                                    <div className="mt-3 text-center mx-auto sm:mt-0 ">
                                        <div className="mt-1">
                                            <p className="text-base text-wrap text-gray-700 font-google font-normal">
                                                {customMessage ? customMessage : `Are you sure you want to delete this  ${boardName}?`}
                                            </p>
                                            <p className="text-base text-gray-700 font-google font-normal">
                                                {customMessage ? '' : 'You will no longer be able to view it.'}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="bg-white px-4 pb-3 flex gap-2 items-center justify-center sm:px-6">
                                <button
                                    type="button"
                                    className="inline-flex justify-center rounded bg-[#42B4F4] px-6 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#42B4F4] border-0 font-google"
                                    onClick={() => {
                                        deleteTaskMail(taskToDeleteId);
                                    }}
                                >
                                    YES, I'M SURE
                                </button>
                                <button
                                    type="button"
                                    className="inline-flex justify-center rounded bg-white px-6 py-2 text-sm font-semibold text-gray-900 shadow-sm border border-gray-300 hover:bg-gray-50 font-google"
                                    onClick={onCancel}
                                >
                                    NO
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ConfirmationPopup.propTypes = {
    item: PropTypes.object.isRequired,
    onDelete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    taskToDeleteId: PropTypes.string.isRequired,
    getTaskMail: PropTypes.func.isRequired,
    deleteTaskMail: PropTypes.func.isRequired,
};

export default ConfirmationPopup;
